import { useNavigate, useSearchParams } from "react-router-dom";
import { submitCourse } from "@/service";


interface SubmitCourseParams {
  address?: any;
  courseId?: number;
  classId?: number;
}


const useSubmitCourse = () => {

  const nav = useNavigate();
  const [searchParams] = useSearchParams();

  const classIdByUrl = searchParams.get('classId');
  const courseIdByUrl= searchParams.get('courseId');

  const go2Error = (msg: string) => {
    nav('/result', {
      state: {
        type: 'error',
        title: '选班失败，请联系辅导老师~',
        message: msg
      }
    });
  }

  const submit = ({
    address,
    courseId,
    classId,
  }: SubmitCourseParams) => {
    let params: {
      courseId: number;
      courseIdSelected: number;
      address?: any;
    }  = {
      courseId: courseId || Number(courseIdByUrl),
      courseIdSelected: classId || Number(classIdByUrl),
      address,
    }

    submitCourse(params).then(({code, msg}) => {
      if(code === 0) {
        nav('/result', {
          state: {
            type: 'success',
            title: '选班成功～'
          }
        });
      }else {
        go2Error(msg)
      }
    }).catch((err) => {
      console.log(err);
      go2Error('网络错误，请稍后再试~')
    })
  }

  return {
    submitCourse: submit,
  }
}



export default useSubmitCourse;
